// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2NV2a{font-size:14px!important;line-height:10px;color:#9b9b9b!important}._2NV2a:hover{text-decoration:none!important}._12Hc7{color:#ff5722!important}@media only screen and (max-width:850px){._2NV2a{font-size:12px!important}}", ""]);
// Exports
exports.locals = {
	"breadcrumbsLink": "_2NV2a",
	"breadcrumbsActiveLink": "_12Hc7"
};
module.exports = exports;
